import { Api } from './index';

export const fetchCoupon = (code) =>
  Api.get(`/products/coupons/lookup?code=${code}`);

export const submitCoupon = (data) => Api.post('/orders/coupon_codes', data);

export const verifyCaptchaRequest = (data) => Api.post('/recaptcha', data);
